import React from "react";
import { useZoom } from "@/contexts/ZoomContext";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import Button from "@components/Button";
import { TooltipContainer } from "@scripts/react/components/Tooltip";

interface ZoomControlsProps {
    className?: string;
    /** Optional controlled mode - provide these to override context */
    onZoomIn?: () => void;
    onZoomOut?: () => void;
    onResetZoom?: () => void;
    /** Optional disabled states for controlled mode */
    canZoomIn?: boolean;
    canZoomOut?: boolean;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
    className,
    onZoomIn: controlledZoomIn,
    onZoomOut: controlledZoomOut,
    onResetZoom: controlledResetZoom,
    canZoomIn = true,
    canZoomOut = true
}) => {
    // Use context if not in controlled mode
    const context = useZoom();
    const zoomIn = controlledZoomIn || context?.zoomIn;
    const zoomOut = controlledZoomOut || context?.zoomOut;
    const resetZoom = controlledResetZoom || context?.resetZoom;

    return (
        <div className={twClassNames("pointer-events-auto flex flex-row items-center", className)}>
            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Zoom Out <span className="hotkey dark ml-1">⌘</span>
                        <span className="hotkey dark ml-1">-</span>
                    </div>
                }
                customButton={
                    <Button
                        onClick={zoomOut}
                        type="ghost"
                        size="xsmall"
                        shape="square"
                        disabled={!canZoomOut}
                    >
                        <i className="fas fa-minus" />
                    </Button>
                }
            />

            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Zoom In <span className="hotkey dark ml-1">⌘</span>
                        <span className="hotkey dark ml-1">+</span>
                    </div>
                }
                customButton={
                    <Button
                        onClick={zoomIn}
                        type="ghost"
                        size="xsmall"
                        shape="square"
                        disabled={!canZoomIn}
                    >
                        <i className="fas fa-plus" />
                    </Button>
                }
            />
            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Reset Zoom <span className="hotkey dark ml-1">⌘</span>
                        <span className="hotkey dark ml-1">0</span>
                    </div>
                }
                customButton={
                    <Button onClick={resetZoom} type="ghost" size="xsmall">
                        Reset
                    </Button>
                }
            />
        </div>
    );
};
